import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=62d6a756"
import script from "./sku.vue?vue&type=script&lang=js"
export * from "./sku.vue?vue&type=script&lang=js"
import style0 from "./sku.vue?vue&type=style&index=0&id=62d6a756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports